import { Button } from "@mui/material";
import { Formik } from "formik";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as Yup from "yup";
import { getModalidadesDenuncia, getTiposSiniestro, } from "../../../redux/actions/denuncia";
import { getDependenciasEmpleador } from "../../../redux/actions/empleador";
import FormikAutocomplete from "../../commons/formik/FormikAutocomplete";
import FormikDatePicker from "../../commons/formik/FormikDatePicker";
import FormikTextField from "../../commons/formik/FormikTextField";
import { StyledSiniestralidad } from "../../styled/Siniestros";

const validationSchema = Yup.object({
  nroSiniestroART: Yup.number().nullable().min(1, "Valor inválido"),
  nroDocumento: Yup.number().nullable().min(1, "Valor inválido"),
  fechaDesde: Yup.date().nullable().typeError("Fecha inválida"),
  fechaHasta: Yup.date()
    .nullable()
    .typeError("Fecha inválida")
    .test({
      name: "fechaHasta",
      message: "La fecha hasta debe ser mayor a la fecha desde",
      test: function (value) {
        return value && this.parent.fechaDesde
          ? value > this.parent.fechaDesde
          : true;
      },
    }),
});

const SiniestroFilterForm = ({ handleSubmit, initialValues }) => {
  const dispatch = useDispatch();

  const modalidades = useSelector((state) => state.denuncia.modalidades);
  const tiposSiniestro = useSelector((state) => state.denuncia.tiposSiniestro);
  const dependenciasEmpleador = useSelector(
    (state) => state.empleador.dependenciasEmpleador
  );

  useEffect(() => {
    dispatch(getDependenciasEmpleador())
  }, [dispatch]);

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
    >
      {({ values }) => (
        <StyledSiniestralidad.FormContainer>
          <StyledSiniestralidad.RowContainer>
            <StyledSiniestralidad.FilterItem>
              <FormikTextField
                name="nroSiniestroART"
                label="Nro. Siniestro"
                type="number"
              />
            </StyledSiniestralidad.FilterItem>
            <StyledSiniestralidad.FilterItem>
              <FormikAutocomplete
                name="idModalidadDenuncia"
                label="Modalidad de denuncia"
                options={modalidades.data}
                getOptions={() => dispatch(getModalidadesDenuncia())}
              />
            </StyledSiniestralidad.FilterItem>
            <StyledSiniestralidad.FilterItem>
              <FormikAutocomplete
                name="idTipoSiniestro"
                label="Tipo Siniestro"
                options={tiposSiniestro.data}
                getOptions={() => dispatch(getTiposSiniestro())}
              />
            </StyledSiniestralidad.FilterItem>
            <StyledSiniestralidad.EstablecimientoCombo>
              <FormikAutocomplete
                name="idDependenciaEmpleador"
                label="Establecimiento"
                options={dependenciasEmpleador.data}
                getOptions={() => dispatch(getDependenciasEmpleador())}
              />
            </StyledSiniestralidad.EstablecimientoCombo>
          </StyledSiniestralidad.RowContainer>
          <StyledSiniestralidad.RowContainer>
            <StyledSiniestralidad.FilterItem>
              <FormikTextField
                name="nroDocumento"
                label="Nro. Documento"
                type="number"
              />
            </StyledSiniestralidad.FilterItem>
            <StyledSiniestralidad.FilterItem>
              <FormikTextField name="apellido" label="Apellido" type="text" />
            </StyledSiniestralidad.FilterItem>
            <StyledSiniestralidad.FilterItem>
              <FormikTextField name="nombres" label="Nombre" type="text" />
            </StyledSiniestralidad.FilterItem>
            <StyledSiniestralidad.FilterItem>
              <FormikDatePicker
                name="fechaDesde"
                label="Ocurrencia desde"
                ampm="false"
                format="dd/MM/yyyy"
                variant="inline"
              />
            </StyledSiniestralidad.FilterItem>
            <StyledSiniestralidad.FilterItem>
              <FormikDatePicker
                name="fechaHasta"
                label="Ocurrencia hasta"
                ampm="false"
                format="dd/MM/yyyy"
                variant="inline"
              />
            </StyledSiniestralidad.FilterItem>
            <StyledSiniestralidad.ButtonContainer>
              <Button
                color="primary"
                variant="contained"
                type="submit"
                disabled={
                  !(
                    values.nroSiniestroART !== null ||
                    values.idModalidadDenuncia !== "" ||
                    values.idTipoSiniestro !== "" ||
                    values.idDependenciaEmpleador !== "" ||
                    values.nroDocumento !== "" ||
                    values.apellido !== "" ||
                    values.nombres !== "" ||
                    values.fechaDesde !== null ||
                    values.fechaHasta !== null
                  )
                }
              >
                Buscar
              </Button>
            </StyledSiniestralidad.ButtonContainer>
          </StyledSiniestralidad.RowContainer>
        </StyledSiniestralidad.FormContainer>
      )}
    </Formik>
  );
};

export default SiniestroFilterForm;
